module.exports = __webpack_public_path__ + "img/2024-03-19e_3.a765a2c6.jpg";